import { ActionType } from "../../../../../../react-core/Flux/ActionType";
import { AccountSearchQueryClient } from "../../../../../../Wrap/Api/Account/AccountSearchQuery";
import { AccountType } from "../../../../../../Wrap/Constants/Enums/Domain/AccountType";
import { MultiPropositionType } from "../../../../../../Wrap/Constants/Enums/Domain/MultiPropositionType";
import { SubAccountType } from "../../../../../../Wrap/Constants/Enums/Domain/SubAccountType";
import { AdvancedSearchFilterType } from "../../../../../../Wrap/Constants/Enums/Search/AdvancedSearchFilterType";
import { AccountStatus } from "../../../../../../Wrap/Models/Domains/Account/SlAccounts/AccountStatus";
import { getStatus } from "../Resource/Contents";
import { AccountSearchDispatcher, AccountSearchStore } from "../Store/Variable";

export interface IBasicSearchQuery {
    accountName?: string;
    accountNum?: string;
    adviser?: string;
    accountType?: AccountType;
    status?: AccountStatus;
    network?: string;
    company?: string;
    ServicePropositionsToExclude?: MultiPropositionType[];
}

export interface IAdvancedSearchQuery {
    filterType?: AdvancedSearchFilterType;
    wrappers?: SubAccountType[];
    investedInMandates?: boolean;
    mandateNames?: string[];
    hasRegularPayments?: boolean;
    hasRegularWithdrawals?: boolean;
}

export class AccountSearchAction {
    public static searchAccounts(
        query: IBasicSearchQuery,
        advancedSearchFilter: IAdvancedSearchQuery[],
        currentPage,
        count,
        callBack?: (val: any) => void
    ): void {
        const wrappers = advancedSearchFilter?.find((ele) => ele?.filterType == AdvancedSearchFilterType.Wrapper);
        const mandate = advancedSearchFilter?.find((ele) => ele?.filterType == AdvancedSearchFilterType.Mandate);
        const regularPayment = advancedSearchFilter?.find(
            (ele) => ele?.filterType == AdvancedSearchFilterType.RegularPayment
        );
        const regularWithdrawal = advancedSearchFilter?.find(
            (ele) => ele?.filterType == AdvancedSearchFilterType.RegularWithdrawal
        );
        const client = new AccountSearchQueryClient();
        const promise = client.get(
            query.accountName,
            query.accountNum,
            query.adviser,
            query.accountType,
            getStatus(query.status),
            query.company,
            query.network,
            currentPage,
            count,
            advancedSearchFilter?.length > 0 ? AdvancedSearchFilterType.Wrapper : null, // this can be any value in filter type enum, just need a value to represent advance filter is enabled
            wrappers?.wrappers,
            mandate?.investedInMandates,
            mandate?.mandateNames,
            regularPayment?.hasRegularPayments,
            regularWithdrawal?.hasRegularWithdrawals,
            query.ServicePropositionsToExclude
        );
        promise.onSuccess((res) => {
            let data = JSON.parse(JSON.stringify(AccountSearchStore.getData()));
            if (!data) {data = {};}
            data = res;
            AccountSearchDispatcher.dispatch({
                actionType: ActionType.Success,
                payload: data,
            });
            console.log(data);
            if (callBack) {
                callBack(res);
            }
        });

        promise.onError((err) => {
            AccountSearchDispatcher.dispatch({
                actionType: ActionType.Error,
                payload: err,
            });
        });
    }
}
